import { connect } from 'react-redux';
import WidgetDisplay from '../components/WidgetDisplay';

const mapStateToProps = (state) => {
	return {
		widgetState: state.widgetState,
		prefs: state.prefs
	};
};

const Widget = connect(mapStateToProps)(WidgetDisplay);

export default Widget;
